import styled from 'styled-components';

export const SubtasksFieldContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  border-radius: 3px;
`;
